var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-module-tab",class:{'flex-column': _vm.flexColumn, 'flex': _vm.flexRow, 'flex-grow-auto': !_vm.columnScroll, 'flex-grow': _vm.columnScroll, 'z-active': _vm.activatedState}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }